// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zUGzm","left":"styles_left__31UJ_","desktopActions":"styles_desktopActions__cax4v","title":"styles_title__10aym"};